import { globalGetService } from '@/utils/globalApiServices';
import { ApprovedMno, UserProfile, DcaItem } from './types';

export const getAllDcas = async (params?: Record<string, unknown>) => {
  const response = await globalGetService('dca/dcas', params);
  return (response?.ok ? response.data : []) as DcaItem[];
};

export const getProfile = async () => {
  const response = await globalGetService('dca/dcas/me');
  return response?.ok ? (response.data as UserProfile) : undefined;
};

export const getApprovedMnos = async () => {
  const response = await globalGetService('dca/dcas/myApprovedMno');
  return (response?.ok ? response.data : []) as ApprovedMno[];
};
